import { render } from "./DeptPicker.html?vue&type=template&id=178a4b2f&scoped=true&ts=true"
import script from "./DeptPicker.ts?vue&type=script&lang=ts"
export * from "./DeptPicker.ts?vue&type=script&lang=ts"

import "./DeptPicker.scss?vue&type=style&index=0&id=178a4b2f&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-178a4b2f"]])

export default __exports__